import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import { BsGear } from "react-icons/bs";
import { SiNvidia } from "react-icons/si";
import FormatDateTime from "../../../../Functions/FormatDate";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Spinner from "../../../../Components/Spinner";
import ErrorMessage from "../../../../Components/ErrorMessage";

const ScaleModal = ({ show, handleClose, selectedNodes, fetchRecords }) => {
    const { t } = useLanguage();
    const navigate = useNavigate()
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, clus_id, link_page } = useParams()
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState("");

    const [inputValue, setInputValue] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [recordId, setRecordId] = useState("");
    const [orgName] = useState(`Scale`);


    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value === orgName + " " + selectedNodes) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    const handleCloseModal = () => {
        setRecordId("")
        setIsButtonDisabled(true);
        handleClose()
        setError({ message: "", display: false })
        setInputValue("")
    }


    const closeModal = () => {
        // fetchRecords()
        setInputValue("")
        handleClose();
    };

    const scaleNodes = async () => {
        setLoading(true);
        setError(false);
        setMessage("");

        try {
            const response = await fetch("http://127.0.0.1:5000/scale_k8s_cluster_nodes", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id, clus_id, nodes: selectedNodes }),
            });

            const result = await response.json();

            if (response.ok) {
                closeModal()
                 navigate(`/project_panel/${project_id}/clusters/loading_cluster/${clus_id}`);
            } else {
                setError(true);
            }
        } catch (err) {
            console.error(err);
            setError(true);
            setMessage("An error occurred.");
        }

        setLoading(false);
    };


    return (
        <Modal show={show} onHide={handleCloseModal} className="modal_delete">
            <div className="modal_header">
                <p>Do you want to scale this resource?</p>
                <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
            </div>
            <div className="modal_body">
                <p className="warning_delete_message"> <p>You can scale nodes up or down as needed. This action is reversible and can be adjusted again at any time.</p>
                    <p>Learn more in our <strong>documentation</strong>.</p></p>
                <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{orgName} {selectedNodes}</strong></p>

                    <input
                        className="delete_input"
                        placeholder={orgName +" " +selectedNodes}
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>

            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className={`activate_btn ${isButtonDisabled ? "" : "activate_btn_active"}`}
                        onClick={scaleNodes}
                        disabled={isButtonDisabled}
                    >
                        {loading ? (
                            <Spinner loading={loading} />
                        ) : (
                            <>Scale</>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={closeModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ScaleModal;


// dtn_a8ffd591258cf9936fa3c1f06940818be92996bc82f57cc0c8569c131b74ffda
// https://app.daytona.io/api